@if (isRedesignView$ | async) {
    <div class="appHeader redesign">
        @if (isHighlights$ | async) {
            <img class="appLogo"
                 src="assets/img/highlights.svg"
                 alt="highlights logo"
                 role="presentation"
            />
        } @else {
            <img class="appLogo"
                 src="assets/img/zb-icon-white.svg"
                 alt="zb logo"
                 role="presentation"
            />
        }
    </div>
}